// @flow
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { showConfirmation, hideConfirmation, updateConfirmationButtons } from 'app/common/actions/confirmation';


type ConfirmationProps = {
  message: string,
  confirmButtonTitle: string,
  cancelButtonTitle: string,
  // confirmButtonAdditionalProps
  onConfirm: () => void | Promise<void>,
}

export default function useConfirmation() {
  const dispatch = useDispatch();

  const handleConfirmationShow = useCallback(({
    message,
    confirmButtonTitle,
    cancelButtonTitle,
    onConfirm,
  }: ConfirmationProps) => {
    const handleConfirm = (e: SyntheticEvent<HTMLElement>) => {
      e.preventDefault();
      onConfirm();
    };

    const handleCancel = (e?: SyntheticEvent<HTMLElement>) => {
      if (e) {
        e.preventDefault();
      }
      dispatch(hideConfirmation());
    };

    dispatch(showConfirmation({
      text: message,
      buttons: [{
        value: confirmButtonTitle,
        onClick: handleConfirm,
        key: 'remove',
      }, {
        value: cancelButtonTitle,
        outline: true,
        onClick: handleCancel,
        key: 'cancel',
      }],
    }));
  }, [dispatch]);

  const handleLockConfirmation = useCallback(() => {
    dispatch(updateConfirmationButtons([{
      disabled: true,
      // value: '...Удаляется',
    }]));
  }, [dispatch]);

  const handleConfirmationHide = useCallback(() => {
    dispatch(hideConfirmation());
  }, [dispatch]);

  return [handleConfirmationShow, handleConfirmationHide, handleLockConfirmation];
}
